<template>
  <el-dialog :visible.sync="visible" title="开票户头" :close-on-click-modal="false"
             :close-on-press-escape="false">
    <div class="table-bar">
      <div></div>
      <el-button  size="mini" type="primary" @click="addOrUpdateHandle()">
        {{ $t('add') }}
      </el-button>
    </div>
    <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle"
              style="width: 100%;">
      <el-table-column prop="accountName" label="户头名称" header-align="center" align="center"></el-table-column>
      <el-table-column prop="bankName" label="开户行" header-align="center" align="center"></el-table-column>
      <el-table-column prop="accountNo" label="银行账号" header-align="center" align="center"></el-table-column>
      <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
        <template slot-scope="scope">
          <el-button v-if="$hasPermission('trade:companyaccount:update')" type="text" size="small"
                     @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}
          </el-button>
          <el-button v-if="$hasPermission('trade:companyaccount:delete')" type="text" size="small"
                     @click="deleteHandle(scope.row.id)">{{ $t('delete') }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
    </el-pagination>
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
  </el-dialog>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './add-or-update'

export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/trade/company/account/page',
        getDataListIsPage: true,
        deleteURL: '/trade/company/account',
        deleteIsBatch: true,
        activatedIsNeed:false
      },
      visible: false,
      dataForm: {
        companyId: ''
      }
    }
  },
  components: {
    AddOrUpdate
  },
  methods: {
    init (companyId) {
      this.dataForm.companyId=companyId
      this.reload()
      this.visible = true
    }
  }
}
</script>
